import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Colores from './views/Colores.vue'
import Caracteres from './views/Caracteres.vue'
import Tamanios from './views/Tamanios.vue'
import Razas from './views/Razas.vue'
import Mascotas from './views/Mascotas.vue'
import Visitas from './views/Visitas.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Inicio',
      component: Home
    },
    {
      path: '/colores',
      name: 'Colores',
      component: Colores
    },
    {
      path: '/caracteres',
      name: 'Caracteres',
      component: Caracteres
    },
    {
      path: '/tamanios',
      name: 'Tamaños',
      component: Tamanios
    },
    {
      path: '/razas',
      name: 'Razas',
      component: Razas
    },
    {
      path: '/mascotas',
      name: 'Mascotas',
      component: Mascotas
    },
    {
      path: '/visitas/:mascotaId',
      name: 'Visitas',
      component: Visitas
    }
  ]
})
